import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  contactPretitle = 'Let\'s Connect';
  contactTitle = 'Get in Touch';
  contactContent = 'I am available for freelance work or full-time positions. Feel free to reach out to me via email, and I will get back to you as soon as possible.';
  contactBtnText = 'Send Email';

  constructor(

  ) { }

  ngOnInit(): void {
  }
}
